<template>
    <div class="gcmcn-card taker-configuration">
        <div class="taker-configuration-container">
            <configuration-preview
                v-if="canStartPreview"
                :configuration="takerConfigurationRelatedToChannel"
                :default-image="thumbnailUrl"
                :width="208"
                :height="117"
            ></configuration-preview>
            <div
                class="taker-infos"
                :class="canStartPreview?'taker-info-column':''"
            >
                <img
                    class="taker-logo"
                    :src="taker.logo"
                >
                <span>{{ taker.name}}</span>
            </div>
            <configuration-button
                v-if="channel.status !== 'FINISHED'"
                :channel="channel"
                :configuration="takerConfigurationRelatedToChannel"
                @create-configuration="onCreateconfiguration"
                @on-configuration-cancelled="$emit('on-configuration-cancelled')"
            ></configuration-button>
        </div>
        <div
            class="configurations-container"
        >
            <configuration-detail
                :configuration="lastConfiguration"
                :configurations-count="filteredConfigurations.length"
                :stream-type="'channel'"
                :dashboard-card="true"
                @trigger-refresh="triggerRefresh"
            ></configuration-detail>
        </div>
    </div>
</template>

<script>
import ConfigurationPreview from '@/components/ChannelAndConfigurationPreview'
import ConfigurationButton from './configurationButton';
import { ConfigurationDetail } from 'gcmcn-common';
export default {

    components: {
        ConfigurationButton,
        ConfigurationDetail,
        ConfigurationPreview
    },

    props: {
        taker: {
            type: Object,
            required: true,
        },
        configurations: {
            type: Array,
            required: true,
        },
        channel: {
            required: true,
            type: Object,
        },
    },

    data (){
        return {
            thumbnailTimeout: null,
            thumbnailUrl: ''
        };
    },

    computed: {
        filteredConfigurations() {
            return this.configurations.filter(configuration => {
                return configuration.channel_uid === this.channel.uid && configuration.taker_uid === this.taker.uid && !['FAILED', 'ABORTED'].includes(configuration.status);
            }).sort((a,b) => {
                return new Date(b.creation_date) - new Date(a.creation_date);
            });
        },
        lastConfiguration(){
            if(this.filteredConfigurations.length > 0){
                return this.filteredConfigurations[0];
            }
            return {};
        },
        takerConfigurationRelatedToChannel (){
            return this.configurations.find((conf) => {
                return conf.taker_uid === this.taker.uid &&
                       !['FINISHED',/*'FINISHING',*/ 'FAILED', 'FAILED_TO_CONNECT', 'ABORTED'].includes(conf.status) &&
                       conf.cancelled === false /*&& conf.finished === false*/;
                       // this filter is the same as the filter in gcmcn-front-common
                       // the two commented part of the filter were bloquing configuration once they were finished
            }) || null;
        },
        canStartPreview(){
            if(this.takerConfigurationRelatedToChannel!== null && this.takerConfigurationRelatedToChannel.status === 'CONNECTED'){
                return true;
            }
            return false;
        }
    },
    watch: {
        canStartPreview: function(val){
            if(val){
                this.startThumbnailFetch();
            }else{
                this.stopThumbnailFetch();
            }
        }
    },
    mounted (){
        if(this.canStartPreview){
            this.startThumbnailFetch();
        }
    },
    beforeDestroy(){
        this.stopThumbnailFetch();
    },
    methods: {
        onCreateconfiguration (){
            this.$emit('on-load-taker-group', true);
            this.$store.dispatch('remoteGet', {
                url: `group/${this.taker.group_uid}`
            })
            .then((res) => {
                this.$emit('on-load-taker-group', false);
                this.$emit('create-configuration', this.taker, res.data);
            }).finally(() => {
                this.$emit('on-load-taker-group', false);
            });
        },
        fetchThumbnail(){
            this.$store.dispatch('remoteGet', {
                url: this.lastConfiguration.url,
            }).then(res => {
                if(res.data.thumbnail_url !== ''){
                    this.$set(this, 'thumbnailUrl', res.data.thumbnail_url);
                }else {
                    this.$set(this, 'thumbnailUrl', 'static/image/configuration-no-thumbnail-assetHD.jpg');
                }
            });
        },
        startThumbnailFetch(){
            if(this.channel.enable_thumbnail_generation){
                this.thumbnailTimeout = setInterval(() =>{
                    this.fetchThumbnail();
                }, 1000);
            }
        },
        stopThumbnailFetch(){
            clearInterval(this.thumbnailTimeout);
        },
        triggerRefresh(){
            this.$emit('trigger-refresh');
        }
    },
};
</script>

<style lang="scss">
.taker-configuration{
    position:relative;
    height: auto;
    min-height: 130px;

    & + .taker-configuration{
        margin-top: 10px;
    }
    .taker-configuration-container{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        .taker-infos{
            flex-grow: 1;
            margin-left: 0.5rem;
            .taker-logo{
                width: 35%;
                max-width: 100px;
                margin-right: 15px;
            }
        }
        .taker-info-column{
            display: flex;
            flex-direction:column;
        }
    }
    .configurations-container{
        display: flex;
        flex-direction: column;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Channels/taker-configuration.vue